// Mobiel menu (off-canvas) — zonder jQuery.
// Open/dicht via de hamburgerknop (.c-nav-toggle); sluit bij klik op de pagina, Escape of zodra het venster
// desktopbreedte (1024px) bereikt, want daar staat het menu gewoon in de header.
const body = document.body;
const toggle = document.querySelector<HTMLElement>('.c-nav-toggle');
const desktop = window.matchMedia('(min-width: 1024px)');

function setOpen(open: boolean) {
    body.classList.toggle('is-activeNav', open);
    if (toggle) { toggle.setAttribute('aria-expanded', String(open)); }
}

if (toggle) {
    toggle.setAttribute('aria-expanded', 'false');
    toggle.addEventListener('click', (event) => {
        event.preventDefault();
        setOpen(!body.classList.contains('is-activeNav'));
    });
}

const main = document.querySelector('main');
if (main) { main.addEventListener('click', () => setOpen(false)); }

document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && body.classList.contains('is-activeNav')) {
        setOpen(false);
        if (toggle) { toggle.focus(); }
    }
});

desktop.addListener((event) => {
    if (event.matches) { setOpen(false); }
});

export {};
